var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0803 18.5918H3.7793C3.3653 18.5918 3.0293 18.2558 3.0293 17.8418C3.0293 17.4278 3.3653 17.0918 3.7793 17.0918H10.0803C10.4943 17.0918 10.8303 17.4278 10.8303 17.8418C10.8303 18.2558 10.4943 18.5918 10.0803 18.5918Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1906 8.90039H12.8906C12.4766 8.90039 12.1406 8.56439 12.1406 8.15039C12.1406 7.73639 12.4766 7.40039 12.8906 7.40039H19.1906C19.6046 7.40039 19.9406 7.73639 19.9406 8.15039C19.9406 8.56439 19.6046 8.90039 19.1906 8.90039Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.113 6.5C5.224 6.5 4.5 7.216 4.5 8.097C4.5 8.977 5.224 9.692 6.113 9.692C7.003 9.692 7.726 8.977 7.726 8.097C7.726 7.216 7.003 6.5 6.113 6.5ZM6.113 11.192C4.397 11.192 3 9.804 3 8.097C3 6.39 4.397 5 6.113 5C7.83 5 9.226 6.39 9.226 8.097C9.226 9.804 7.83 11.192 6.113 11.192Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3874 16.207C16.4974 16.207 15.7734 16.923 15.7734 17.803C15.7734 18.684 16.4974 19.399 17.3874 19.399C18.2764 19.399 18.9994 18.684 18.9994 17.803C18.9994 16.923 18.2764 16.207 17.3874 16.207ZM17.3874 20.899C15.6704 20.899 14.2734 19.51 14.2734 17.803C14.2734 16.096 15.6704 14.707 17.3874 14.707C19.1034 14.707 20.4994 16.096 20.4994 17.803C20.4994 19.51 19.1034 20.899 17.3874 20.899Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.41da1dbe15dae24530c674ea83601aae.svg";
export { ForwardRef as ReactComponent };